import React from 'react';
import ArrowLeftBlack from "../Images/ArrowLeftBlack";
import BetaIcon from "../Images/BetaIcon";
import styled from "styled-components";

const BetaBlock:React.FC <{modalToggle: any, handleToggle: any}> = ({modalToggle, handleToggle}) => {
    return (
        <Container modalToggle={modalToggle}>

            <ArrowBlock onClick={handleToggle} >
                <div style={{transform: 'rotate(-180deg)'}}>
                    <ArrowLeftBlack/>
                </div>
            </ArrowBlock>
            <ContentBlock>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <BadgeBlock>
                        <BetaIcon/>
                        <span>beta</span>
                    </BadgeBlock>
                </div>
                <div style={{padding: '0 32px 24px'}}>
                    <p>Thank you for joining the Syloom beta! From now on, your progress will be saved. At the end of the beta, users who send feedback will get bonus points.</p>
                    <p>You can also earn USDT rewards for every unique bug you find and submit.</p>
                    <Link href={process.env.REACT_APP_BETA_BUG_URL} target="_blank">list of known issues</Link>
                    <LinkSubmit href={process.env.REACT_APP_BETA_REPORT_URL} target="_blank">submit a bug</LinkSubmit>
                </div>
            </ContentBlock>
        </Container>
    );
};

export default BetaBlock;

const Container = styled.div<{modalToggle: boolean}>`
    position: absolute;
    top: 35px;
    width: calc(100% - 16px);
    right: ${({modalToggle}) => modalToggle ? 0 : "-100%"};
    transition: right 0.5s ease;
    color: #000;
    display: flex;
    z-index: 20;
`;
const ArrowBlock = styled.div`
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    background-color: #F1D988;
`
const ContentBlock = styled.div`
    background-color: #fff;
    height: 100%;
    width: 100%;
    text-align: left;
`
const BadgeBlock = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    align-items: center;
    justify-content: center;
    height: 46px;
    padding: 0 12px;
    font-family: ZenDots, sans-serif;
    font-size: 10px;
    font-weight: 400;
`
const Link = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid #000;
    height: 28px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    font-weight: 600;
    max-width: 196px;
`
const LinkSubmit = styled(Link)`
    margin-top: 12px;
    background-color: #000;
    color: #fff;
`
